var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navbar',{attrs:{"user":_vm.user}}),_c('v-main',[_c('router-view',{key:_vm.$route.path})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }